import { ActionStatus } from '@common/constants/shared';
import { signupUserSuccess } from '@common/redux/slice/auth';
import store from '@common/redux/store';
import io from '@common/services/featherIO/feathers.io';
import { MetadataAction } from '@common/types/action';
import { get, pick } from 'lodash';
import { ActionResponse } from '../excuteAction';
import { handleError } from '../func/func';
import { registerFCMUser, unregisterFCMUser } from './FCMregister';
import { appInfoSelector } from '@common/redux/selectors/app';
import { sendEventAnalytics } from './trackingAnalytics';
import { ActionType } from 'click-types';

export const signUp: (
  action: any,
  metadata: MetadataAction
) => Promise<ActionResponse> = async (
  action: any,
  metadata: MetadataAction
) => {
  try {
    const { messages } = metadata;
    const dispatch = store.dispatch;

    if (action.status === ActionStatus.ERROR) {
      return {
        status: ActionStatus.FAILED,
        message: handleError(action.error, messages) || '',
      };
    }

    const response = get(action, 'response');
    await unregisterFCMUser(); //remove old token
    const appInfo = appInfoSelector(store.getState())!;
    if (appInfo) {
      await registerFCMUser(response, appInfo);
    }
    await io.authenticate({
      strategy: 'jwt',
      accessToken: response?.accessToken,
    });

    dispatch(
      signupUserSuccess({
        user: {
          ...response,
          appId: appInfo.id,
          ...pick(response, ['createdAt', 'updatedAt', 'databaseId']),
        },
      })
    );

    const isTrackingEnabled =
      metadata.actionItem?.options?.trackAnalytics === true;
    if (isTrackingEnabled) {
      try {
        const formData = {
          user_id: response?.id,
          database_id: response?.databaseId,
          ...metadata.record,
          datasourceId: metadata.actionItem?.options?.datasourceId,
          tableId: metadata.actionItem?.options?.tableId,
        };

        await sendEventAnalytics({
          actionType: ActionType.SIGNUP,
          id: 'signup',
          options: {
            eventName: metadata.actionItem?.options?.eventName || 'click_signup',
            formData: formData,
            fbPixelContentName:
              metadata.actionItem?.options?.eventName || 'User Registration',
            fbPixelStatus: true,
          },
          status: 'success',
        });
      } catch (error) {
        console.warn('Signup tracking failed:', error);
      }
    }
    return {
      status: ActionStatus.SUCCESS,
      message: messages['auth_signupSuccess'],
      accessToken: response?.accessToken,
      profile: response,
    };
  } catch (error: any) {
    console.log('error', error);
    return { status: ActionStatus.FAILED, message: error.message };
  }
};
